import zhHKLocat from 'vxe-table/lib/locale/lang/zh-HK';

export default {
    weekday:{
      1:"星期 1",
      2:"星期 2",
      3:"星期 3",
      4:"星期 4",
      5:"星期 5",
      6:"星期 6",
      7:"星期日",
    },
    button: {
      back: "返回",
      confirm: "確定",
      create: "新增",
      edit: "編輯",
      cancel: "取消",
      login: "登入",
      select_all: "選擇全部",
      clear: "重置",
      reset: "重置",
      connect: "連接",
      disconnect: "斷開連接",
      default: "預設",
      save: "儲存",
      send: "傳送",
      reconnect: "重新連線",
      stop_charging: "終止充電",
      reboot: "重新啟動",
      go_detail: "充電點資料",
      show_charging_detail: "充電詳情",
      mass_update: "批量更新",
      filter: "篩選"
    },
    error: {
      generic: "發生錯誤",
      400: "請求錯誤",
      403: "操作權限不足或帳號已登出",
      404: "此頁面不存在",
      no_changes: "未有作任何更改",
      10001:"此充电器不存在!",
      10003:"請輸入有效的持續時間!",
      10004:"請輸入手機號碼最後四位數字!",
      10002:"啟動充電器錯誤!",
      10009:"充電槍錯誤!",
      10011:"獲取收費數據錯誤!",
      30001:"入場時間錯誤!",
      30002:"沒相對應的交易記錄!",
      30003:"請輸入車牌!",
      10007:"Rsr Not found",
      10008:"接駁器錯誤",
      10009:"接駁器錯誤",
      10013:"Rsr Invalid",
      10014:"Member Id Invalid",
      10015:"充電插頭尚未準備妥當或不可用",
      10016:"Connector status error",
      10017:"充電線未能接上",
      10018:"MaxSessionReached",
      10019:"CpChargingRateMissing",
      10022:"Connector cannot use. Chargers only allow maximum one connector charging",
      21001:"Number of session not match",
      21002:"invalid time to redeemed",
      21004:"invalid member id",
      21005:"Failed",
      40001: "Payment Not Found",
      40002: "Payment is Already Settled",
      40003: "Payment is Already retry",
      40004: "Invalid Record",
      40005: "Payment record invalid",
      40006: "Cp is occupied by another Bay",
    },
    menu: {
      group: {
        setting: "系統設置",
        management: "管理",
        operation: "營運",
        lms: "LMS"
      },
      item: {
        home: "首頁",
        user: "系統用戶",
        role: "使用者身份",
        cp: "充電點",
        cp_request: "充電點請求日誌",
        cp_session: "充電點交易記錄",
        cp_rsr_request: "充電點遠程啟動請求記錄",
        cp_rsr_api_log: "充電點遠程啟動Api Log",
        cp_rsr_point_redeem: "30天積分兌換紀錄",
        cpRsrPointRedeem: "30天積分兌換紀錄",
        account: "帳戶",
        role_n_permission: "身份與權限設定",
        privilege: "權限",
        vehicle: "車輛",
        user_log: "用戶日誌",
        cp_request_test: "LMS測試",
        cp_loc: "充電位置",
        cp_zone: "充電區域",
        lms_dashboard: "LMS儀表版",
        lms_config: "LMS設定",
        lms_profile: "LMS配置",
        cp_config: "充電配置(Deprecated)",
        cp_simulator: "充電點模擬器",
        zone_lms_profile: "充電區域LMS配置",
        realtime_log: "實時LMS訊息",
        account_service_plan: "帳戶服務計劃",
        service_plan: "服務計劃",
        account_vehicle: "車輛記錄",
        cp_power_meter: "電表型號",
        data_rotation_setup: "數據輪換",
        cp_meter_value: "電表讀數",
        district: "分區",
        account_status: "用戶狀態",
        third_party_conf: "第三方應用配置",
        third_party_configuration: "第三方應用配置",
        third_party_reservation_log: "第三方預約記錄",
        cp_sessions_all: "充電點交易記錄",
        auth_card: "授權卡",
        opening_hour:"營業時間",
        change_availability:"更改狀態",
        master_flag: "管理員卡核取方塊",
        alert:"系統警報",
        contact:"聯繫人",
        contact_group:"聯繫人群組",
        app_config:"系統配置",
        cp_rsr: "充電點RSR",
        archive_cp_rsr: "充電點RSR(封存)",
        cp_rsr_request: "充電點RSR請求",
        cp_rsr_api_log: "充電點API日誌",
        delete:"移除按鈕",
        dashboard_summary:"儀表板摘要",
        cp_connector: "充電槍配置",
        charging_rate: "充電收費率配置",
        cp_type: "充電器種類",
        payment_result_detail: "支付紀錄",
        third_party_error_log: "API錯誤紀錄",
        remote_start_charger: "遠端啟動按鈕",
        retry_error_payment: "重新支付按鈕",
        remote_reset_charger: "重啟充電點按鈕",
        bay: "車位",
        penalty_button: "調整停止懲罰按鈕",
        bay_log: "車位更新紀錄",
        portal_action_log: "用戶操作日誌",
        get_giagnostics:"獲取診斷",
        trigger_message: "獲取狀態",
        user_profile: "用戶資料",
        voucher:"充電兌換券列表",
        settled_button:"手動完成付款",
        campaign:"充電推廣活動",
        campaign_rule:"活動規則",
        price_scheme:"價格方案",
        member_tier: "會員級別",
      }
    },
    label: {
      menu: "選單",
      trash: "未啟用",
      go_to: "前往",
      total_record_desc: "共 {row} 項資料 | 共 {row} 項資料，第 {page}/{max_page} 頁",
      greeting: "你好，",
      logout: "登出",
      no_data_found: "請更新篩選條件",
      export_as_: "匯出至",
      confirm_to_save: "確定保存",
      assign_cp_to_zone: "分派充電點到此充電區域",
      charger: "充電器",
      immediate: "立即",
      mode: "模式",
      max: "最大",
      show_per_page: "每頁顯示",
      all: "全部",
      start_charger:"啟動充電器",
      stop_charger:"停止充電",
      reset_charger:"重啟充電器",
      connector_id:"充電槍",
      duration:"持續時間（分鐘）",
      start_code:"PIN",
      lp:"車牌",
      entry_time:"入位時間",
      is_free:"免費",
      remark:"備註",
      unlock_charger:"緊急解鎖",
      get_giagnostics:"獲取診斷",
      trigger_message:"更新充電器狀態",
      status: "狀態",
      import:"導入",
      downloadDemo:"下載範本",
      importFile:"導入文件",
      confirmImport:"確認導入"
    },
    placeholder: {
      please_input: "請輸入",
      please_select: "請選擇合適項目",
      all_locs: "-- 所有位置 --",
      all_chargers: "-- 所有充電器 --",
      invalid: "不適用"
    },
    filter: {
      start_date: "開始日期",
      end_date: "結束日期",
      to: "至",
      boolean: {
        true: "是",
        false: "否"
      }
    },
    select: {
      today: "本日",
      in7days: "7日內",
      in1months: "30日內",
      all: "全部"
    },
    message: {
      logout_warning: "確定要登出嗎?",
      login_failed: "登入失敗，帳號或密碼有誤",
      server_error: "伺服器出現錯誤，請稍後再試",
      network_error: "伺服器連接失敗，請確保已連接網絡",
      confirm_n_items_is_changes: "{x}個項目被更改，確定要保存？",
      sure_service_restart_required: "當資料儲存後，程式將會重新啟動，確定要保存嗎?",
      sure_to_stop_charging_session: "確定要終止 {cp_no} 的充電嗎?",
      mass_update_warning: "以下充電點目前沒有「充電配置」，所以無法批量更新",
      save_successfully: "儲存成功",
      confirm_to_remove_app_secret: "確定要移除 (編號:{id}, 密鑰名稱:{key_name}) 的配置嗎?",
      confirm_to_delete: "確定要移除 (編號:{id}) 的數據嗎?",
      confirm:"確定",
      cancel:"取消",
      9001:"同時會刪除全部交易記錄!",
      change_availability:"更改設置為：{type}",
      cp: "充電點[{id}]",
      confirm_start_charger: "確定{action}?",
      max_limit: "最多選擇{limit}個",
      maximumQuantity: "最多導入{row}行",
      pleaseSelectExcelFile: "請選擇Excel文件",
      no_suitable_option_found:"沒有找到合適的選項"
    },
    field: {
      general: {
        cp_no: "充電點編號",
        connector_id: "充電槍編號",
        cp_id: "編號",
        cre_user: "創建者",
        lupd_dttm: "最後更新日期/時間",
        lupd_user: "最後更新者",
        id: "編號",
        cp_name: "停車位編號",
        cre_dttm: "請求日期時間",
        remark: "備註",
        remarks: "備註",
        session_id: "交易編號",
        cp_config_id: "配置編號",
        action_button: "",
        update_time: "最後更新日期/時間",
        mac_address: "MAC地址",
        ip_address: "IP地址",
        description: "備註",
        fw_ver: "固件版本",
        current: "目前",
        pending: "待定",
        create: "新增",
        request_data: "請求數據",
        response_data: "回應數據",
        api_log_type:  "請求類別",
        url:"URL",
        id_tag:"卡號碼",
        cancel:"取消",
        creDttm: "創建時間",
        lupdDttm: "最後更新時間",
        connectorStatus: "充電槍狀態",
        email: "電郵",
        redeem_voucher_sessions:"充電兌換券實際使用量",
        redeem_voucher_size:"充電兌換券會員選擇量",
        redeemVoucherSessions:"充電兌換券實際使用量",
        campaignName:"活動",
        session:"第{session}節",
        point:"積分",
        cash:"現金",
        delete:"刪除",
        date:"日期",
        startTime:"開始時間",
        endTime:"結束時間"
      },
      member_tier:{
        tier: "會員級別",
        tierName: "會員級別名稱",
        monthlyChargingLimit:"每月差電換領限制"
      },
      price_scheme:{
        name:"名稱",
        locId:"車場ID",
        type:"類別",
        maxChargingUnit:"每次最大差電節數",
        fee:"每節費用",
        priceSchemeDetail:"價格方案詳情",
        version:"版本"
      },
      campaign:{
        name:"推廣活動名稱(Eng)",
        nameCHT:"推廣活動名稱(繁)",
        nameCHS:"推廣活動名稱(简)",
        faceValue:"兌換券面值",
        externalCampaignId:"推廣活動編號",
        applicableTime:"適用時段(Eng)",
        applicableTimeCHT:"適用時段(繁)",
        applicableTimeCHS:"適用時段(简)",
        maxChargingUnit:"每次最大差電節數",
        address: "商場",
        fee:"每節費用",
        tnc:"條款與細則 (Eng)",
        tncCHT:"條款與細則 (繁)",
        tncCHS:"條款與細則 (简)",
        locIds:"適用商場限制",
        isAllCpLocFlag:"允許全部商場使用",
        creUserName:"創建者",
        addresses: "適用商場限制"
      },
      campaign_rule:{
        campaignId:"活動編號",
        campaignRuleTypeCode:"設置推廣活動使用限制",
        campaignRuleConfig:"配置",
        ruleName: "設置推廣活動使用限制",
        campaignName: "推廣活動名稱",
        description: "適用時段描述 (顯示在App充電券詳情頁)(Eng)",
        descriptionCht: "適用時段描述 (顯示在App充電券詳情頁)(繁)",
        descriptionChs: "適用時段描述 (顯示在App充電券詳情頁)(簡)"
      },
      contact_group: {
        contact_group_id: "編號",
        name: "名稱",
        status:"啟用",
        level:"接收頻率",
        contactIds:"聯繫人",
        locIds:"充電位置",
        errorIds: "錯誤編碼",
      },
      contact:{
        contact_id: "編號",
        name: "名稱",
        email: "電郵",
        status:"啟用",
      },
      users: {
        id: "使用者編號",
        name: "名稱",
        role_id: "使用者身份",
        username: "帳號",
        active: "已啟用",
        password: "密碼",
        confirm_password: "確認密碼",
        cp_loc_flag: "顯示全部充電點位置",
        loc_id: "充電點位置"
      },
      user_profile: {
        id: "使用者編號",
        name: "名稱",
        role_id: "使用者身份",
        username: "帳號",
        active: "已啟用",
        password: "密碼",
        confirm_password: "確認密碼",
        cp_loc_flag: "顯示全部充電點位置",
        loc_id: "充電點位置"
      },
      roles: {
        name_chi: "名稱",
        role: "使用者身份",
      },
      alert:{
        alert_id: "編號",
        cp_id: "充電點編號",
        error_id: "錯誤編碼",
        location:"充電位置",
        message:"錯誤信息",
        last_date:"最後紀錄日期",
        cre_dttm:"偵測日期",
        level:"連續偵測次數",
        is_fixes:"已解決",
      },
      portal_action_log:{
        action:"操作",
        target:"目標頁面",
        target_id:"目標編號",
        old_data:"更新前數據",
        new_data:"更新數據"
      },
      cps: {
        cp_id: "編號",
        name: "停車位編號",
        name_chi: "停車位編號",
        loc_id: "位置",
        firmware_version: "固件版本",
        charging_status_code: "充電狀態",
        charging_status: "充電狀態",
        connectora_status: "充電槍1狀態",
        connectorb_status: "充電槍2狀態",
        last_status_dttm: "狀態最後更新",
        boot_dttm: "啟動日期/時間",
        enable_flag: "已啟用",
        max_power_output: "最大輸出功率",
        heartbeat_interval: "心跳間隔（秒）",
        private_flag: "私人充電點",
        ac_flag: "快充",
        dc_flag: "中充",
        mac_addr: "MAC地址",
        ip: "IP地址",
        port: "端口",
        charge_box_serial_number: "充電器編號",
        charge_point_model: "充電點型號",
        charge_point_serial_number: "充電點序列號",
        charge_point_vendor: "充電點供應商",
        iccid: "ICC ID",
        imsi: "IMSI",
        meter_serial_number: "電表序列號",
        meter_type: "電表類型",
        error_code: "錯誤代碼",
        mct_status_code: "MCT狀態代碼",
        cre_dttm: "建立日期/時間",
        connector: "充電槍",
        freecharge_flag: "免費充電點",
        power_meter_name: "電表型號",
        power_meter_factor: "倍率",
        power_meter_rotation_value: "最大電表讀數",
        mass_update: "批量更新",
        power_meter_type_id: "電表型號",
        change_availability:"暫停使用",
        min_current_threshold:"最小電流",
        min_power_threshold:"低功率警告(瓦)",
        power_meter_type_id: "電表型號",
        cp_connectors: "充電槍",
        charger_type: "充電器種類",
        cp_type: "充電器種類",
        double_use_flag: "充電槍同時使用"
      },
      cp_requests: {
        tran_id: "充電點交易編號",
        cp_id: "*充電器編號",
        cp_no: "充電點編號",
        req_id: "編號",
        request_type:  "請求類別",
        request_data: "請求數據",
        response_data: "回應數據",
        loc: "位置",
        firmware_version: "固件版本",
        energy: "能量(kWh)",
        voltage: "電壓(V)",
        ampere: "電流(A)",
        charge_box_serial_number: "充電器編號",
        rsr_id: "RSR編號"
      },
      cp_sessions: {
        cp_id: "充電器編號",
        cp_no: "充電點編號",
        tran_id: "充電點交易編號",
        total_pw_consume: "使用電力總量(kWh)",
        total_charge_time: "充電總時間",
        running_pw_consume: "運作中電力總量(kWh)",
        session_start_time: "交易開始時間",
        session_end_time: "交易結束時間",
        connector_name: "充電槍編號",
        account_id: "帳戶",
        start_meter: "開始時電表值(kWh)",
        end_meter: "結束時電表值(kWh)",
        charge_box_serial_number: "充電器編號",
        start_soc: "開始時SoC(%)",
        end_soc: "結束時SoC(%)",
      },
      cp_sessions_all: {
        tran_id: "充電點交易編號",
        cp_id: "充電器編號",
        cp_no: "充電點編號",
        total_pw_consume: "使用電力總量(kWh)",
        total_charge_time: "充電總時間",
        running_pw_consume: "運作中電力總量(kWh)",
        session_start_time: "交易開始時間",
        session_end_time: "交易結束時間",
        connector_id: "充電槍編號",
        account_id: "帳戶車牌號碼",
        start_meter: "開始時電表值(kWh)",
        end_meter: "結束時電表值(kWh)",
        charge_box_serial_number: "充電器編號",
        start_soc: "開始時SoC(%)",
        end_soc: "結束時SoC(%)",
        id_tag: "卡號碼"
      },
      payment_result_detail: {
        resultId : "支付編號",
        paymentType: "支付種類",
        referenceMemberId: "會員編號",
        status: "狀態",
        amount: "費用($)",
        point: "分數",
        actionType: "方式",
        requestReference: "請求參考",
        transactionReference: "回應參考",
        currentUnitSession: "節數",
        autoPaymentExpiredTime: "自動付款逾期時間",
        actualFinishedTime: "停止懲罰時間",
        startTime: "開始時間",
        endTime: "結束時間",
        gracingPeriodEndDttm: "寬限期結束時間",
        penaltyDuration: "懲罰時間",
        retry: "重試支付"
      },
      charging_rate:{
        name: "規則名稱",
        // energy_rate: "能量單位費用($/kwh)",
        // time_rate: "時間單位費用($/時間單位)",
        // penalty_rate: "罰款單位費用($/時間單位)",
        // point_rate: "單位費用(point/時間單位)",
        // peak_energy_rate: "高峰時段能量單位費用($/kwh) (高峰時段)",
        // peak_time_rate: "時間單位費用($/時間單位) (高峰時段)",
        // peak_penalty_rate: "罰款單位費用($/時間單位) (高峰時段)",
        // peak_point_rate: "單位費用(point/時間單位) (高峰時段)",
        loc_id: "充電點位置",
        gracing_period: "寬限期",
        max_charging_unit: "每次最大差電節數",
        max_penalty_unit: "最大罰款時間(分鐘)",
        max_daily_charging_session:"每日最多充電次數",
        redeem_period: "換分限期(分鐘)",
        max_redeem_count: "最大分數換領次數",
        unit: "時間收費單位",
        type: "收費準則",

      },charging_rate_detail: {
        startTime:"時段開始時間",
        endTime:"時段結束時間",
        fee:"每節費用",
        peak:"高峰時段",
        point:"分數",
        // weekday:"weekday",
        penaltyUnit:"罰款單位",
        unit:"單位",
        penaltyFee:"罰款費用",
        maxChargingUnit: "每次最大差電節數",
        priceSchemeId:"價格方案"
      },
      cp_rsr: {
        rsr_id: "編號",
        actual_end_time: "實際完結時間",
        cancel_time: "取消時間",
        connector_id: "充電槍編號",
        duration: "充電時間(分鐘)",
        end_time: "完結時間",
        lp: "車牌",
        start_code: "PIN",
        start_time: "開始充電時間",
        status: "狀況",
        payment_status: "付款狀況",
        payment_status_name: "付款狀況",
        charging_fee: "充電收費",
        penalty_fee: "罰款收費",
        point: "已換領分數",
        tran_id: "充電點交易編號",
        unit_in_minutes: "單位時間(分鐘)",
        rate: "單位費用",
        uuid: "UUID",
        stop_type: "停止方式",
        stop_type_name: "停止方式",
        stop_reason: "停止原因",
        external_account_id: "會員編號",
        carpark_id: "車場編號",
        mall_id: "商場編號",
        loc_address: "商場地址",
        connector_name: "充電槍編號",
        payment_result_id: "支付編號",
        current_unit_session: "充電節數",
        max_charging_unit: "總充電節數",
        brand_in: "入場品牌",
        lp_in: "入場車牌",
        brand_out: "出場品牌",
        lp_out: "出場車牌",
        in_time: "入位時間",
        out_time: "離位時間",
        lprs_session_id: "LPRS 時段ID",
        lprs_out_session_id: "LPRS 離場時段ID",
        ev_disconnect_time: "拔槍時間",
        actual_finished_time: "停止罰款時間",
        penalty_button: "懲罰時間調整",
        settled_button:"手動完成付款",
        bay_id_int: "車位編號",
        bay_id: "車位",
        bay_name: "車位",
        gracing_period_end_dttm: "寬限期結束時間",
        cre_dttm: "創建時間",
        penalty_mode: "懲罰規則",
        next_available_redeem_date:"下次可使用積分兌換日期",
        shk30day_redeem_count: "30日累績換分次數",
        reservation_type:"預約類型",
      },
      archive_cp_rsr: {
        rsr_id: "編號",
        actual_end_time: "實際完結時間",
        cancel_time: "取消時間",
        connector_id: "充電槍編號",
        duration: "充電時間(分鐘)",
        end_time: "完結時間",
        lp: "車牌",
        start_code: "PIN",
        start_time: "開始充電時間",
        status: "狀況",
        payment_status: "付款狀況",
        payment_status_name: "付款狀況",
        charging_fee: "充電收費",
        penalty_fee: "罰款收費",
        point: "已換領分數",
        tran_id: "充電點交易編號",
        unit_in_minutes: "單位時間(分鐘)",
        rate: "單位費用",
        uuid: "UUID",
        stop_type: "停止方式",
        stop_type_name: "停止方式",
        stop_reason: "停止原因",
        external_account_id: "會員編號",
        carpark_id: "車場編號",
        mall_id: "商場編號",
        loc_address: "商場地址",
        connector_name: "充電槍編號",
        payment_result_id: "支付編號",
        current_unit_session: "充電節數",
        max_charging_unit: "總充電節數",
        brand_in: "入場品牌",
        lp_in: "入場車牌",
        brand_out: "出場品牌",
        lp_out: "出場車牌",
        in_time: "入位時間",
        out_time: "離位時間",
        lprs_session_id: "LPRS 時段ID",
        lprs_out_session_id: "LPRS 離場時段ID",
        ev_disconnect_time: "拔槍時間",
        actual_finished_time: "停止罰款時間",
        penalty_button: "懲罰時間調整",
        settled_button:"手動完成付款",
        bay_id_int: "車位編號",
        bay_id: "車位",
        bay_name: "車位",
        gracing_period_end_dttm: "寬限期結束時間",
        cre_dttm: "創建時間",
        penalty_mode: "懲罰規則",
        next_available_redeem_date:"下次可使用積分兌換日期",
        shk30day_redeem_count: "30日累績換分次數"
      },
      cpRsrPointRedeem: {
        rsr_id: "編號",
        actual_end_time: "實際完結時間",
        cancel_time: "取消時間",
        connector_id: "充電槍編號",
        duration: "充電時間(分鐘)",
        end_time: "完結時間",
        lp: "車牌",
        start_code: "PIN",
        start_time: "開始充電時間",
        status: "狀況",
        payment_status: "付款狀況",
        payment_status_name: "付款狀況",
        charging_fee: "充電收費",
        penalty_fee: "罰款收費",
        point: "已換領分數",
        tran_id: "充電點交易編號",
        unit_in_minutes: "單位時間(分鐘)",
        rate: "單位費用",
        uuid: "UUID",
        stop_type: "停止方式",
        stop_type_name: "停止方式",
        stop_reason: "停止原因",
        external_account_id: "*會員編號",
        carpark_id: "車場編號",
        mall_id: "商場編號",
        loc_address: "商場地址",
        connector_name: "充電槍編號",
        payment_result_id: "支付編號",
        current_unit_session: "充電節數",
        max_charging_unit: "總充電節數",
        brand_in: "入場品牌",
        lp_in: "入場車牌",
        brand_out: "出場品牌",
        lp_out: "出場車牌",
        in_time: "入位時間",
        out_time: "離位時間",
        lprs_session_id: "LPRS 時段ID",
        lprs_out_session_id: "LPRS 離場時段ID",
        ev_disconnect_time: "拔槍時間",
        actual_finished_time: "停止罰款時間",
        penalty_button: "懲罰時間調整",
        settled_button:"手動完成付款",
        bay_id_int: "車位編號",
        bay_id: "車位",
        bay_name: "車位",
        gracing_period_end_dttm: "寬限期結束時間",
        cre_dttm: "充電日期時間",
        penalty_mode: "懲罰規則",
        next_available_redeem_date_from_create_date:"下次可使用積分兌換日期(如當前已使用有次積分兌換)",
        shk30day_redeem_count: "30日累績換分次數"
      },
      third_party_error_log: {
        action: "行動",
        carparkId: "車場編號",
        mallId: "商場編號",
        memberId: "會員編號",
        chargerId: "充電點編號",
        connectorId: "充電槍編號",
        connectorStatus: "充電槍狀況",
        errorCode: "錯誤代碼",
        errorTime: "錯誤時間",
        reason: "原因",
        rsrId: "RSR 編號"
      },
      cp_session_detail: {
        energy: "電表讀數(kWh)",
        voltage: "電壓(V)",
        ampere: "電流(A)",
      },
      cp_pow: {
        name: "名稱",
        factor: "倍率",
        rotation_value : "最大電表讀數"
      },
      accounts: {
        acc_id: "帳戶編號",
        first_name: "名字",
        last_name: "姓",
        mobile_no: "手機號碼",
        email: "電郵",
        acc_bal: "餘額",
        hkid: "身分證/護照(頭3位數字)",
        birthday: "生日",
        acc_status: "帳戶狀態",
        default_lang: "預設語言",
        tnc_flag: "測試和調試用戶",
        rfid_cards: "RFID卡(以 , 分隔)",
        address: "地址",
        reg_dttm: "註冊日期時間",
        car_reg_no: "車輛號碼",
        locIds:"充電位置",
        master_flag: "管理員卡",
        max_charge_time: "最長充電時間（分鐘）"
      },
      privileges: {
        name: "鍵",
        enable_flag: "已啟用",
      },
      vehicles: {
        vehicle_id: "車輛編號"
      },
      user_log: {
        user_log_id: "用戶日誌編號",
        msg: "日誌內容",
        type: "類別",
        ip: "IP地址",
        user_id: "用戶名稱",
      },
      cp_locs: {
        loc_id: "編號",
        address: "地址",
        enable_flag: "已啟用",
        provider_id: "供應商",
        mode_id: "收費模式",
        district_id: "區",
        address_chi: "地址（中文）",
        address_chs: "地址（簡體)",
        gps_lat: "緯度",
        gps_lang: "經度",
        rate_id: "充電收費",
        min_charging_unit: "最小充電單位（預付）",
        max_charging_unit: "最大充電單位（預付）",
        default_charging_unit: "預設充電單位（預付）",
        free_charge_flag: "免費",
        postpaid_min_charge: "最低收費（港幣） (後付)",
        postpaid_max_charge: "最高收費（港幣） (後付)",
        postpaid_allowance_min: "寬限（分鐘） (後付)",
        lms_profile_id: "LMS配置",
        enable_lms: "啟用LMS",
        external_loc_id: "車場ID",
        mall_id: "商場ID",
        station_code: "車場ID",
        contact_number:"聯繫電話",
        enable_reservation: "啟用預約",
        payment_carpark_id:"付款車場ID"
      },
      bay: {
        bayId: "車位編號",
        bayName: "車位名稱",
        cpLocId: "車場",
        cpConnector:"充電槍",
        locId: "車場ID",
        mallId:"商場ID",
        cpId: "充電點",
        connectorId: "充電槍",
        brand: "品牌",
        licensePlate: "車牌",
        inTime: "入場時間",
        outTime: "離場時間",
        type: "車位種類",
        status: "車位狀況",
        image: "車相",
        autoDownloadFlag: "自動下載圖片",
        penaltyMode: "懲罰規則",
        urlGetBayInfo: "車位狀況API URL"
      },
      bay_log:{
        sessionId: "LPRS 時段ID",
        bayId: "車位ID",
        brand: "品牌",
        licensePlate: "車牌",
        image: "車相",
        imageLocalPath: "車相",
        locId: "*車場ID",
        mallId: "商場ID",
        inTime: "入場時間",
        outTime: "離場時間",
        creDttm: "創建時間",
        errorCode: "錯誤代碼",
        response: "API回應",
        status:"狀況",
        requestStatus: "請求狀況",
        bayUpdateStatus:"車位更新狀況",
        relatedRsr: "RSR編號",
      },
      cp_zones: {
        zone_id: "編號",
        loc_id: "位置",
        name_chi: "名稱",
        max_physical_current_limit: "最大物理電流上限"
      },
      role_n_permission: {
        read: "讀取",
        create: "新增",
        edit: "修改",
        other: "其他"
      },
      lms: {
        mode: "模式",
        zone_max_available_current: "區域最大可用電流",
        max_charging_current: "最大充電電流",
        min_charging_current: "最低充電電流",
        zone_name: "區域名稱"
      },
      lms_profiles: {
        lms_profile_id: "編號",
        name: "名稱",
        cp_loc: "位置",
        mode: "模式",
      },
      account_service_plans: {
        asp_id: "編號",
        start_date: "計劃開始日期",
        end_date: "計劃結束日期",
        acc_id: "帳戶",
        plan_id: "服務計劃",
        plan_total: "計劃總額",
        cp_id: "充電點編號"
      },
      service_plans: {
        plan_id: "編號",
        name: "名稱"
      },
      account_vehicles: {
        acc_id: "車輛編號",
        cp: "充電器",
        car_reg_no: "車輛號碼",
        monthly_charging_time: "本月充電時間",
        monthly_charged_energy: "本月充電量(kWh)",
        daily_charging_time: "本日充電時間",
        daily_charged_energy: "本日充電量(kWh)",
        acc_status: "車輛狀態",
        rfid_cards: "RFID卡(以 , 分隔)"
      },
      data_rotation_setup: {
        period_month: "保留時間 (月份)",
        is_enabled: "已啟用",
      },
      sys_logs: {
        log_message: "日誌",
        created_dt: "建立日期/時間"
      },
      third_party_conf: {
        key_name: "密鑰名稱",
        app_id: "應用編號",
        assigned: "已授權",
        privilege_key: "權限",
        api_key: "應用密鑰"
      },
      auth_card: {
        name: "名稱",
        rfid_cards: "RFID卡(以 , 分隔)",
        loc: "充電位置",
        cp: "充電器",
        active: "已啟用"
      },
      opening_hour: {
        opening_hour_id:"編號",
        name: "名稱",
        start_time: "開始時間",
        end_time: "結束時間",
        weekday: "星期",
      },
      voucher: {
        memberId:"會員編號",
        rsrId:"RSR編號",
        status:"充電兌換券狀態",
        creUserName:"創建者",
        deleteDttm:"刪除日期",
        address:"已充電商場地址",
        redeemDttm:"兌換日期",
        voucherExpireDate:"優惠券有效日期",
        campaignId:"推廣活動名稱",
        campaignId2:"推廣活動編號",
        locId:"兌換券發行商場",
        faceValue:"兌換券面值"
      }
    },
    input_error: {
      already_taken: "已被取用",
      already_exist: "已存在",
      email_is_null: "必填",
      email_duplicate: "已存在",
      email_error: "格式錯誤",
      status_error:"請選擇(聯繫人,充電位置,錯誤編碼)",
      CARD_NO_ALREADY_EXIST: "號碼已被其他帳號取用",
      END_TIME_MORE_THAN_START_TIME: "必須大於開始時間",
      REQUIRED: "必填",
      DUPLICATE_KEY: "已被取用",
      PriceSchemeMCULessChargingRateDetailMCU: "PriceSchemeMCULessChargingRateDetailMCU ({0})",
      CampaignRuleTypeCodeDuplicate: "CampaignRuleTypeCodeDuplicate",
      NotEditable: "NotEditable",
      priceSchemeAndMaxChargingUnitError: "priceSchemeAndMaxChargingUnitError",
      ExpireDateAlreadyExpire: "Expire Date is Already Expire",
      MAX_CHARGE_TIME_NOT_INTEGER: "必須是整數",
      MAX_CHARGE_TIME_NOT_IN_RANGE: "的合資格範圍：0 - 1440"
    },
    error: {
      CampaignIdIsNull: "推廣活動名稱不可為空",
      ExpireDateAlreadyExpire: "Expire Date is Already Expire",
      LocIdIsNull: "兌換券發行商場不可為空",
    },

    unit: {
      sec: "時間"
    },

    dashboard: {
      status: {
        Available: "可用",
        Faulted: "發生故障",
        Finishing: "完成中",
        Preparing: "準備中",
        Reserved: "已預約",
        SuspendedEV: "EV已暫停",
        SuspendedEVSE: "EV已暫停",
        Unavailable: "不可用",
        Charging: "充電中",
        Offline: "離線",
        na: "不適用",
      },
      daterange: {
        yesterday: "昨日",
        today: "今日",
        weekly: "過去7日"
      },
      unit: {
        time: {
          hr: "小時",
          min: "分鐘",
        },
      },
      label: {
        charging_status: "充電概況",
        usage: "使用率",
        used: "已使用",
        not_used: "未使用",
        consumption: "用量",
        start_from: "開始於",
        end_on: "結束於",
        not_in_use: "未使用",
        voltage: "電壓",
        current: "電流",
        time: "時間",
        bayStatus: "車位狀況",
        bayLupdDttm: "車位最後更新時間"
      }
    },
    lms: {
      label: {
        start_tran_at: "開始充電時間",
        start_queueing_at: "開始輪候時間",
        charging_end_at: "預計結束時間",
        select_time: "選取的充電時間"
      },
      mode: {
        unknown: "未知",
        queueing: "輪候",
        distribution: "分配",
        mixmode: "混合",
        
      },
      status: {
        available: "可用",
        charging: "充電中",
        disconnected: "離線",
        queueing: "輪候中",
        Available: "可用",
        Faulted: "發生故障",
        Finishing: "完成中",
        Preparing: "準備中",
        Reserved: "已預約",
        SuspendedEV: "EV已暫停",
        SuspendedEVSE: "EV已暫停",
        Unavailable: "不可用",
        Charging: "充電中"
      }
    },
    data_rotation_setup: {
      item: {
        cp_request: "充電點請求日誌",
        cp_session: "充電點時段",
        cp_meter_value: "電表讀數",
        transaction: "充電點交易記錄"
      }
    },
    third_party_reservation_log: {

        type: "類型",
        memberId: "會員編號",
        response: "回應"

    },
    ...zhHKLocat
  }